import { IProposal } from './types';

export const proposalInitialState: IProposal = {
  financing: {
    numberOfInstallments: 0,
    installmentValue: 0,
    releasedAmount: 0,
    minimumEntryPercentage: 0,
    firstInstallmentDate: '',
    inputValue: 0,
    totalFinancingAmount: 0,
    requestedAmount: 0,
  },
  product: {
    name: '',
    price: 0,
    discount: 0,
  },
  financingDetails: {
    accessoriesValue: 0,
    insuranceValue: 0,
    insuranceName: '',
  },
};
